import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="16" cy="16" fill="#EAF6ED" r="14" />
        <circle cx="16" cy="14" fill="#3EA966" r="6" />
        <path
            d="M15 28C11.9326 28 9.06127 26.6279 7.28781 25.2365C6.48603 24.6074 6.53979 23.4475 7.31873 22.7904C9.46894 20.9765 12.6534 19 16 19C18.5515 19 22.5498 21.1701 24.9187 23.0494C25.5931 23.5844 25.7336 24.539 25.0706 25.0882C23.1657 26.6664 19.0829 28 15 28Z"
            fill="#3EA966"
            stroke="#3EA966"
            strokeLinecap="round"
            strokeWidth="2"
        />
        <path
            clipRule="evenodd"
            d="M26.1815 22.3542C27.3339 20.5115 28 18.3335 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 18.3335 4.66608 20.5115 5.81849 22.3542C7.36789 20.1447 9.64302 18.9928 11.9662 18.4418C10.7583 17.3442 10 15.7606 10 14C10 10.6863 12.6863 8 16 8C19.3137 8 22 10.6863 22 14C22 15.7606 21.2417 17.3442 20.0338 18.4418C22.357 18.9928 24.6321 20.1447 26.1815 22.3542ZM24.8948 24.0551C23.0762 20.9032 19.4264 20 16 20C12.5736 20 8.92383 20.9032 7.10523 24.0551C9.30082 26.4781 12.4727 28 16 28C19.5273 28 22.6992 26.4781 24.8948 24.0551ZM16 18C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10C13.7909 10 12 11.7909 12 14C12 16.2091 13.7909 18 16 18ZM16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
            fill="#2C5E40"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
